<template>
  <!-- <div class="sidebar-footer"></div> -->
</template>
<script>

export default {
  name: 'sidebar-footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Sidebar/SidebarFooter.vue